module.exports = __webpack_public_path__ + "img/20200218155542320.d2dcdee0.jpg";